import React, { useState } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import AddPersonalModal from '../add/AddPersonalModal';
import { useSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from '../../../config/axiosInstance';

const ActionButtons = ({ refreshData, buttonText }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleAddPersonal = async (employeeData) => {
    const params = new URLSearchParams({
      name: employeeData.name,
      surname: employeeData.surname,
      ci: employeeData.ci,
      position: employeeData.position,
      override_manager: employeeData.override_manager,
      is_night: employeeData.is_night,
      override_night: employeeData.override_night,
      employment_regime: employeeData.employment_regime,
      rest_policy: employeeData.rest_policy,
      assignment_mode: employeeData.assignment_mode,
      station: employeeData.station,
      workarea: employeeData.workarea,
      is_manager: employeeData.is_manager,
      first_day: employeeData.first_day, // Incluye el campo first_day
      aux_workareas: employeeData.aux_workareas || '',
      weekly_schedule: employeeData.weekly_schedule || '',
    });
  
    try {
      const response = await axiosInstance.post(`/personal/add_save?${params.toString()}`);
      await refreshData();

      const updatedCalendars = Number(response?.data?.calendar_sync?.updated_calendars || 0);
      const detail = updatedCalendars > 0
        ? ` Se actualizaron ${updatedCalendars} calendario(s) abierto(s).`
        : '';

      enqueueSnackbar(`Empleado agregado correctamente.${detail}`, {
        variant: 'success',
        autoHideDuration: 3000,
        action: (key) => (
          <IconButton onClick={() => closeSnackbar(key)} sx={{ color: 'inherit' }}>
            <CloseIcon />
          </IconButton>
        )
      });

      handleCloseModal();
      return response;
    } catch (error) {
      console.error('Error al agregar el empleado:', error);
      enqueueSnackbar(error.response?.data?.error || 'Error al agregar el empleado', { 
        variant: 'error',
        autoHideDuration: 3000,
        action: (key) => (
          <IconButton onClick={() => closeSnackbar(key)} sx={{ color: 'inherit' }}>
            <CloseIcon />
          </IconButton>
        )
      });
      throw error;
    }
  };
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 2, width: '100%' }}>
      <Button 
        variant="contained" 
        sx={{ 
          backgroundColor: 'primary.main', 
          color: 'primary.light', 
          mr: 2,
          '&:hover': {
            color: 'secondary.light', // Cambia el color del texto al hacer hover
          }
        }}
        onClick={handleOpenModal}
      >
        {buttonText.buttonAddPersonal} {/* Usar el texto de Agregar Empleado */}
      </Button>
      

      <AddPersonalModal
        open={modalOpen}
        handleClose={handleCloseModal}
        handleAddPersonal={handleAddPersonal}
      />
    </Box>
  );
};

export default ActionButtons;



/*
<Button 
        variant="contained" 
        sx={{ 
          backgroundColor: 'secondary.light', 
          color: 'primary.dark',
          mr: 2,
          '&:hover': {
            color: 'white', // Cambia el color del texto al hacer hover
          }
        }}
        onClick={handleOpenImportDialog}
      >
        {buttonText.buttonImportPersonal} 
      </Button>

      <Dialog
        open={importDialogOpen}
        onClose={handleCloseImportDialog}
        aria-labelledby="import-xls-dialog-title"
      >
        <DialogTitle id="import-xls-dialog-title">Seleccionar archivo XLSX</DialogTitle>
        <DialogContent>
          <input type="file" accept=".xls, .xlsx" onChange={handleFileUpload} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImportDialog} color="primary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
      */
